// extracted by mini-css-extract-plugin
module.exports = {"levelsSection":"DisciplinesLevelMapper_levelsSection__1tvJm"};